module.exports = __webpack_public_path__ + "static/img/ccode.c3da66c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/ccode.jpg
// module id = qEgK
// module chunks = 44